import { types as globalTypes } from 'services/store/actions';
import { applyAction, createStatusReducer } from 'services/store/utils-reducers';
import { types } from './definitions';

const initialData = {};

const actionReducers = {
  [globalTypes.LOGOUT]: () => initialData,

  [types.SET_USER]: (state, payload) => ({              // just copy the payload into the state
    ...payload
  }),
}

const dataReducer = (state = initialData, action) => applyAction(actionReducers, state, action);
const statusReducer = createStatusReducer('user', { defaultKey: '*' });

const userReducer = (state = {}, action) => ({
  status: statusReducer(state.status, action),
  data: dataReducer(state.data, action)
});

export default userReducer;